export interface TimeInterval {
  name: string;
  today: boolean;
  start: string;
  end: string;
}

export enum StatisticsQueryOptionTypes {
  AGENT,
  SERVICENUMBER
}

export enum PeriodsOptionTypes {
  Today = 'date.today',
  Yesterday = 'date.yesterday',
  TwoDaysAgo = 'date.2days_ago',
  Last7Days = 'date.last_7days',
  Last30Days = 'date.last_30days',
}

export interface IStatisticsQueryOption {
  type: StatisticsQueryOptionTypes;
  name: string;
  label: string;
  fullNumber: string;
}
